// extracted by mini-css-extract-plugin
export default {"back_button_wrap":"AppPrevButton_back_button_wrap_bAnVa","no_mobile":"AppPrevButton_no_mobile_Z5XLA","back_button_label":"AppPrevButton_back_button_label_yw0M9"};